// ============================================
// TIMING CONSTANTS (centralized for easy tuning)
// ============================================
// Extracted from VoiceBotPanel.tsx in Wave 1 of the widget refactor.
// Pure module-level constants — no React, no side effects.

export const TIMING = {
  DEBOUNCE_MS: 100,              // Debounce between response triggers
  PENDING_QUEUE_DELAY_MS: 25,    // Delay before triggering queued response
  RESPONSE_STALL_TIMEOUT_MS: 12000, // Recover if response is stuck with no audio
  GREETING_TRIGGER_DELAY_MS: 800, // Delay before triggering initial greeting
  GREETING_RETRY_TIMEOUT_MS: 3000, // Timeout to retry if greeting produces no audio
  IDLE_TIMEOUT_SECONDS: 120,     // Session idle timeout (2 minutes)
  IDLE_CHECK_INTERVAL_MS: 10000, // How often to check for idle
  CALENDLY_FORCE_CLOSE_MS: 7000, // Force close after Calendly booking confirmed
  SESSION_END_AUDIO_DELAY_MS: 300, // Delay after bot stops speaking before ending session
} as const
